<template>
	<div>
		<vx-card title="Koppeling met lightspeed" v-if="lightspeed && lightspeed.active">
			<vs-row>
				<vs-col class="pb-3">
					Je hebt een koppeling met jouw lightspeed shop <b>{{ lightspeed.shop_domain }}</b> met shop_id <b>{{ lightspeed.shop_id }}</b>.<br>
				</vs-col>

				<vs-col class="pb-3">
					<div class="flex items-center">
						<vs-switch color="success" v-model="status" @change="changeStatus" :disabled="statusLoading" />
						<font-awesome-icon :icon="['fas', 'cog']" :spin="true" class="fa-icon inline-block ml-4" v-if="statusLoading" />
						<span class="ml-4">Koppeling status </span>
					</div>
					<small>Hiermee kun je de koppeling activeren of deativeren.</small>
				</vs-col>
			</vs-row>
		</vx-card>

		<vx-card title="Gegevens" class="mt-5" v-if="lightspeed && lightspeed.active">
			<vs-row>
				<table>
					<tr>
						<td class="font-semibold">
							API key
						</td>
						<td>
							{{lightspeed.api_key}}
						</td>
					</tr>
					<tr>
						<td class="font-semibold">
							API secret
						</td>
						<td>
							{{lightspeed.api_secret}}
						</td>
					</tr>
					<tr>
						<td class="font-semibold">
							API cluster
						</td>
						<td>
							{{lightspeed.api_cluster}}
						</td>
					</tr>
					<tr>
						<td class="font-semibold">
							API lang
						</td>
						<td>
							{{lightspeed.api_lang}}
						</td>
					</tr>
					<tr>
						<td class="font-semibold">
							Webshop ID
						</td>
						<td>
							{{lightspeed.shop_id}}
						</td>
					</tr>
					<tr>
						<td class="font-semibold">
							Webshop domein
						</td>
						<td>
							<a :href="'https://' + lightspeed.shop_domain" target="_blank">{{lightspeed.shop_domain}}</a>
						</td>
					</tr>
				</table>
			</vs-row>
		</vx-card>

		<vx-card title="Koppelen met lightspeed" v-if="lightspeed && !lightspeed.active">
			<!--			<template slot="actions">-->
			<!--				<vx-tooltip class="flex" text="Hoe en wat?">-->
			<!--					<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>-->
			<!--				</vx-tooltip>-->
			<!--			</template>-->
			<form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" ref="formWizard"
						 finishButtonText="Activeren" nextButtonText="Volgende" backButtonText="Vorige" @on-change="nextClick">
				<tab-content title="Api key aanmaken" class="mb-5">
					<vs-row>
						<vs-col vs-w="12">
							Ga naar je lightspeed-shop en login op het admin gedeelte, www.jouwshop.nl/admin.<br>
							<br>
							<div class="ml-5">
								1. Klik in het menu op "Instellingen" > "Developers"<br>
								<br>
								2. Klikt op "Nieuw API key" en geef je API key een naam bv. "piqwise.com"<br>
								<br>
								3. Activeer API key en seleteer de permissies lezen en schrijven bij "Orders".<br>
								<br>
								4. Klik op opslaan.<br>
							</div>
						</vs-col>
					</vs-row>
				</tab-content>

				<tab-content title="Api keys instellen" class="mb-5">
					<vs-row>
						<vs-col>
							Je key is nu aangemaakt en heeft de juiste rechten. Scroll naar beneden op de pagina in lightspeed. Onderaan de pagina kun je de API Key en API Secret
							kopiëren.<br>
							<br>
							Voer deze in op onderstaande velden. En klik op volgende.<br>
							<br>
						</vs-col>
						<vs-col v-if="tabTwoForm.invalidKeys" class="pb-2">
							<vs-alert color="danger" title="API keys ongeldig" active="true">
								Helaas werken deze API keys niet. Voor de juiste keys in en probeer het opnieuw.<br>
								<br>
								Kom je er niet uit? Neem dan contact met ons op, we helpen je graag!
							</vs-alert>
						</vs-col>
						<vs-col>
							<vs-input label="API key" placeholder="Vul hier je API key in" v-validate="'required'" name="apiKey" class="input-field" v-model="tabTwoForm.apiKey" />
							<span class="text-danger text-sm" v-show="errors.has('apiKey')">{{ errors.first('apiKey') }}</span>&emsp;
						</vs-col>
						<vs-col>
							<vs-input label="API secret" placeholder="Vul hier je API secret in" v-validate="'required'" name="apiSecret" class="input-field"
									  v-model="tabTwoForm.apiSecret" />
							<span class="text-danger text-sm" v-show="errors.has('apiSecret')">{{ errors.first('apiSecret') }}</span>&emsp;
						</vs-col>
						<vs-col>
							<label class="multiselect-label">API cluster</label>
							<vue-multiselect
								v-validate="'required'"
								name="shippingMethod"
								placeholder="Selecteer api cluster"
								v-model="tabTwoForm.apiCluster"
								:options="tabTwoForm.apiClusterOptions"
								:show-labels="false"
								:allow-empty="false"
								:danger-text="errors.first('tabTwoForm.apiCluster')"
								:danger="errors.has('tabTwoForm.apiCluster')"
							/>
						</vs-col>
						<vs-col class="pt-5">
							<label class="multiselect-label">API lang</label>
							<vue-multiselect
								v-validate="'required'"
								name="shippingMethod"
								placeholder="Selecteer api lang"
								v-model="tabTwoForm.apiLang"
								:options="tabTwoForm.apiLangOptions"
								:show-labels="false"
								:allow-empty="false"
								:danger-text="errors.first('tabTwoForm.apiLang')"
								:danger="errors.has('tabTwoForm.apiLang')"
							/>
						</vs-col>
					</vs-row>
				</tab-content>

				<!-- tab 3 content -->
				<tab-content title="Step 3" class="mb-5">
					<vs-row class="pt-5 text-2xl">
						<vs-col vs-w="4" class="text-right pr-2">
							<font-awesome-icon :icon="['fas', 'check']" class="fa-icon text-success" v-if="lightspeed.keys_valid" />
							<font-awesome-icon :icon="['far', 'times-circle']" class="fa-icon text-danger" v-else-if="tabThree.keysFailed" />
							<font-awesome-icon :icon="['fas', 'cog']" :spin="true" class="fa-icon" v-else-if="tabThree.keysLoading" />
							<font-awesome-icon :icon="['far', 'hourglass']" class="fa-icon" v-else />
						</vs-col>
						<vs-col vs-w="8" class="pl-2">
							Api keys opslaan en controleren
						</vs-col>
					</vs-row>
					<vs-row class="pt-5 text-2xl">
						<vs-col vs-w="4" class="text-right pr-2">
							<font-awesome-icon :icon="['fas', 'check']" class="fa-icon text-success" v-if="lightspeed.permissions" />
							<font-awesome-icon :icon="['far', 'times-circle']" class="fa-icon text-danger" v-else-if="tabThree.permissionsFailed" />
							<font-awesome-icon :icon="['fas', 'cog']" :spin="true" class="fa-icon" v-else-if="tabThree.permissionsLoading" />
							<font-awesome-icon :icon="['far', 'hourglass']" class="fa-icon" v-else />
						</vs-col>
						<vs-col vs-w="8" class="pl-2">
							Rechten controleren
							<vs-alert color="danger" title="Onvoldoende rechten!" active="true" v-if="tabThree.permissionsFailed">
								<b>De ingestelde rechten op deze API key en secret zijn onvoldoende.</b>
								Daarom is het voor piqwise niet meer mogelijk de juiste gegevens op te halen bij lightspeed.<br>
								<br>
								Stel bij lightspeed lees + schrijf rechten in voor de categorie "orders".<br>
								<br>
								Dit kun je doen door via "Menu" > "Instellingen" > "Developers", selecteer de juiste key en pas de rechten aan.<br>
								<br>
								<vs-button color="primary" type="filled" @click.native="checkPermissions">Controleer opnieuw</vs-button><br>
							</vs-alert>
						</vs-col>
					</vs-row>
					<vs-row class="pt-5 text-2xl">
						<vs-col vs-w="4" class="text-right pr-2">
							<font-awesome-icon :icon="['fas', 'check']" class="fa-icon text-success" v-if="lightspeed.validated" />
							<font-awesome-icon :icon="['far', 'times-circle']" class="fa-icon text-danger" v-else-if="tabThree.shopInfoFailed" />
							<font-awesome-icon :icon="['fas', 'cog']" :spin="true" class="fa-icon" v-else-if="tabThree.shopInfoLoading" />
							<font-awesome-icon :icon="['far', 'hourglass']" class="fa-icon" v-else />
						</vs-col>
						<vs-col vs-w="8" class="pl-2">
							Webshop informatie opslaan
						</vs-col>
					</vs-row>
					<vs-row class="pt-5 text-2xl">
						<vs-col vs-w="4" class="text-right pr-2">
							<font-awesome-icon :icon="['fas', 'check']" class="fa-icon text-success" v-if="lightspeed.active" />
							<font-awesome-icon :icon="['far', 'times-circle']" class="fa-icon text-danger" v-else-if="tabThree.activateFailed" />
							<font-awesome-icon :icon="['fas', 'cog']" :spin="true" class="fa-icon" v-else-if="tabThree.activateLoading" />
							<font-awesome-icon :icon="['far', 'hourglass']" class="fa-icon" v-else />
						</vs-col>
						<vs-col vs-w="8" class="pl-2">
							Module activeren
						</vs-col>
					</vs-row>
				</tab-content>
			</form-wizard>
		</vx-card>
	</div>
</template>


<script>
import {mapActions, mapGetters} from 'vuex';
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';
import InlineInput from '@/components/InlineInput';
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

Vue.use(VeeValidate);

const messages = {
	custom: {
		apiKey: {
			required: 'Vul je api key in',
		},
		apiSecret: {
			required: 'Vul je api secret in',
		},
		apiCluster: {
			required: 'Vul je api cluster in',
		},
		apiLang: {
			required: 'Vul je api lang in',
		}
	}
};
Validator.localize('nl', messages);

export default {
	name: 'module-webshop-lightspeed',
	components: {
		InlineInput,
		FormWizard,
		TabContent
	},
	data() {
		return {
			loading: true,
			status: true,
			statusLoading: false,
			tabTwoForm: {
				invalidKeys: false,
				apiKey: '',
				apiSecret: '',
				apiClusterOptions: [
					'us1',
					'eu1'
				],
				apiCluster: 'eu1',
				apiLang: 'nl',
				apiLangOptions: [
					'bg',
					'fc',
					'da',
					'nl',
					'en',
					'us',
					'fr',
					'de',
					'el',
					'it',
					'no',
					'pl',
					'pt',
					'ru',
					'es',
					'sv',
					'tr'
				],
			},
			tabThree: {
				keysLoading: false,
				keysFailed: false,
				permissionsLoading: false,
				permissionsFailed: false,
				shopInfoLoading: false,
				shopInfoFailed: false,
				activateLoading: false,
				activateFailed: false,
			}
		}
	},
	mounted() {
		this.$vs.loading();
		this.$store.dispatch('lightspeed/init').then(res => {
			if (this.lightspeed.keys_valid && !this.lightspeed.active) {
				this.$refs.formWizard.changeTab(0, 1);
				this.$refs.formWizard.changeTab(1, 2);
				this.checkPermissions();
			}

			if (this.lightspeed.active) {
				this.status = !this.lightspeed.blocked_by_user;
			}

			this.$vs.loading.close();
			this.loading = false
		})
	},
	computed: {
		...mapGetters({
			lightspeed: 'lightspeed/lightspeed',
		})
	},
	methods: {
		...mapActions({
			refresh: 'lightspeed/refresh'
		}),
		nextClick(prevIndex, nextIndex) {
			if (prevIndex === 1 && nextIndex === 2) {
				this.$validator.validateAll().then(result => {
					if (!result) {
						this.$vs.notify({
							color: 'danger',
							title: 'Gegevens zijn niet opgeslagen',
							text: 'Vul alle velden in',
						});

						this.$refs.formWizard.changeTab(nextIndex, prevIndex);
					} else {
						this.tabThree.keysLoading = true;
						this.tabThree.keysFailed = false;

						this.save().then(res => {
							if (this.lightspeed.keys_valid) {
								this.validKeys();
							} else {
								this.invalidKeys();
							}
						}).catch(err => {
							this.invalidKeys();
						})
					}
				})

			}
		},
		save() {
			return new Promise((resolve, reject) => {
				const params = {
					api_key: this.tabTwoForm.apiKey,
					api_secret: this.tabTwoForm.apiSecret,
					api_cluster: this.tabTwoForm.apiCluster,
					api_lang: this.tabTwoForm.apiLang,
				}

				this.$store.dispatch('lightspeed/update', params).then(res => {
					resolve();
				}).catch(err => {
					reject();
				});
			});
		},
		validKeys() {
			this.tabTwoForm.invalidKeys = false;
			this.tabThree.keysLoading = false;

			this.checkPermissions();
		},
		invalidKeys() {
			this.tabTwoForm.invalidKeys = true;
			this.tabThree.keysFailed = true;
			this.$refs.formWizard.changeTab(1, 2);
		},
		checkPermissions() {
			this.tabThree.permissionsLoading = true;
			this.tabThree.permissionsFailed = false;

			setTimeout(() => {
				this.$store.dispatch('lightspeed/checkPermissions').then(res => {
					if (this.lightspeed.permissions) {
						this.validPermissions();
					} else {
						this.invalidPermissions();
					}
				}).catch(err => {
					this.invalidPermissions();
				});
			}, 1000);
		},
		validPermissions() {
			this.tabThree.permissionsLoading = false;
			this.tabThree.permissionsFailed = false;

			this.checkShopInfo();
		},
		invalidPermissions() {
			this.tabThree.permissionsLoading = false;
			this.tabThree.permissionsFailed = true;
		},
		checkShopInfo() {
			this.tabThree.shopInfoLoading = true;

			setTimeout(() => {
				this.$store.dispatch('lightspeed/checkShopInfo').then(res => {
					if (this.lightspeed.validated) {
						this.validShopInfo();
					} else {
						this.invalidShopInfo();
					}
				}).catch(err => {
					this.invalidShopInfo();
				});
			}, 1000);
		},
		validShopInfo() {
			this.tabThree.shopInfoLoading = false;
			this.tabThree.shopInfoFailed = false;

			this.checkActivate();
		},
		invalidShopInfo() {
			this.tabThree.shopInfoLoading = false;
			this.tabThree.shopInfoFailed = true;
		},
		checkActivate() {
			this.tabThree.activateLoading = true;
			setTimeout(() => {
				this.$store.dispatch('lightspeed/activate').then(res => {
					if (this.lightspeed.active) {
						this.validActivate();
					} else {
						this.invalidActivate();
					}
				}).catch(err => {
					this.invalidActivate();
				});
			});
		},
		validActivate() {
			this.tabThree.activateLoading = false;
			this.tabThree.activateFailed = false;
		},
		invalidActivate() {
			this.tabThree.activateLoading = false;
			this.tabThree.activateFailed = true;
		},
		changeStatus() {
			this.statusLoading = true;

			return new Promise((resolve, reject) => {
				const params = {
					blocked: !this.status,
				}

				this.$store.dispatch('lightspeed/update', params).then(lightspeed => {
					this.statusLoading = false;

					this.status = !lightspeed.blocked_by_user;

					resolve();
				}).catch(err => {
					this.statusLoading = false;

					reject();
				});
			});
		},
		wiki() {
			//todo change url
			//window.open(this.$store.state.wiki.wiki.retailer)
		}
	}
}
</script>
